import {
  createStore,
  compose,
  applyMiddleware,
  combineReducers,
} from 'redux';
import auth from 'reducers/auth';
import application from 'reducers/application';
import app from 'reducers/app';
import organisation from 'reducers/organisation';
import quotes from 'reducers/quotes';
import thunk from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';

const reducer = combineReducers({
  auth,
  app,
  application,
  organisation,
  quotes,
  form: formReducer
});

export const configureStore = () => {
  return compose(
    applyMiddleware(thunk),
  )(createStore)(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
};



// WEBPACK FOOTER //
// ./src/utils/store.js